import React from 'react';
import { Text } from 'src/modules/shared/components/atoms/text';
import type { useI18n } from 'src/modules/shared/hooks/provider-bounded/i18n';
import type { TranslationKey } from 'src/modules/shared/types/i18n/translation-keys.type';

interface PropertyPublishingEmptyPromptProps {
  descriptionKey: TranslationKey;
  titleKey: TranslationKey;
  t: ReturnType<typeof useI18n>['t'];
}

export const PropertyPublishingEmptyPrompt: React.FC<
  PropertyPublishingEmptyPromptProps
> = ({ descriptionKey, titleKey, t }) => (
  <div className="rounded-xl border border-dashed border-slate-200 bg-slate-50 p-4">
    <Text size="small" weight="medium" className="text-slate-800">
      {t(titleKey)}
    </Text>
    <Text size="small" className="mt-1 text-slate-500">
      {t(descriptionKey)}
    </Text>
  </div>
);
